import { createRouter, createWebHistory } from "vue-router";

import SignIn from "@/views/pages/pages/authentication/login/sign-in.vue";
import ExternalSignup from "@/views/pages/pages/authentication/register/register-2.vue";
import PendingSocietes from "@/views/pages/support/pending-societes.vue";
import DevAbonnements from "@/views/pages/support/dev-abonnements.vue";
import ActivityLog from "@/views/pages/support/activity-log.vue";
import Inventory from "@/views/pages/inventory/pos-inventory.vue";
import ProductList from "@/views/pages/inventory/product-list/product-list.vue";
import AddProduct from "@/views/pages/inventory/add-product.vue";
import AddService from "@/views/pages/inventory/add-service.vue";
import EditProduct from "@/views/pages/inventory/edit-product.vue";
import EditService from "@/views/pages/inventory/edit-service.vue";
import ServiceList from "@/views/pages/inventory/service-list/service-list.vue";
import ProductUnitSales from "@/views/pages/inventory/product-unit-sales.vue";
import ManageStocks from "@/views/pages/stock/manage-stocks.vue";
import Dashboard from "@/views/pages/dashboard/pos-dashboard.vue";
import Customers from "@/views/pages/people/pos-customers.vue";
import Employees from "@/views/pages/people/pos-employee.vue";
import Warehouse from "@/views/pages/people/pos-warehouse.vue";
import BonsLivraison from "@/views/pages/people/pos-bon-livraison.vue";
import SalesList from "@/views/pages/sales/sales-list.vue";
import InvoicesList from "@/views/pages/sales/invoices-list.vue";
import Company from "@/views/pages/pages/pos-company.vue";
import Profile from "@/views/pages/pages/pos-profile.vue";
import ProductCategories from "@/views/pages/settings/product-categories.vue";
import ServiceCategories from "@/views/pages/settings/service-categories.vue";
import { getCurrentUser } from "@/services/authService";
import { Modal } from "bootstrap";

// Ensure any open Bootstrap modals/backdrops are closed/removed before navigation.
const hideAllBootstrapModals = () => {
  try {
    document.querySelectorAll(".modal").forEach((el) => {
      const inst = Modal.getInstance(el);
      if (inst) {
        inst.hide();
      } else if (el.classList.contains("show")) {
        el.classList.remove("show");
        el.style.display = "none";
      }
    });
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
    document.body.classList.remove("modal-open");
  } catch (e) {
    // ignore errors during cleanup
  }
};

const routes = [
  { path: "/", name: "login", component: SignIn },
  { path: "/signup", name: "signup", component: ExternalSignup },
  { path: "/support/pending-societes", component: PendingSocietes },
  { path: "/support/abonnements", component: DevAbonnements },
  { path: "/support/activity", component: ActivityLog },
  {
    path: "/produits",
    component: Inventory,
    children: [
      { path: "", redirect: "/produits/list-produits" },
      { path: "list-produits", component: ProductList },
      { path: "ajouter-produit", component: AddProduct },
      { path: "ajouter-service", component: AddService },
      { path: "modification-produit", component: EditProduct },
      { path: "modification-service", component: EditService },
      { path: "service-list", component: ServiceList },
    ],
  },
  { path: "/dashboard", component: Dashboard },
  { path: "/services", component: ServiceList },
  { path: "/stocks", component: ManageStocks },
  { path: "/tiers", component: Customers },
  { path: "/employees", component: Employees },
  { path: "/entrepots", component: Warehouse },
  { path: "/categories", component: ProductCategories },
  { path: "/categories-services", component: ServiceCategories },
  { path: "/ventes-unitaires", component: ProductUnitSales },
  { path: "/produits/ventes-unitaires", redirect: "/ventes-unitaires" },
  { path: "/bonsLivraison", component: BonsLivraison },
  { path: "/devis", component: SalesList },
  { path: "/factures", component: InvoicesList },
  { path: "/societe", component: Company },
  { path: "/profile", component: Profile },
  { path: "/:pathMatch(.*)*", redirect: "/dashboard" },
];

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes,
});

function isTokenExpired() {
  const token = localStorage.getItem("access_token");
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch (e) {
    return true;
  }
}

router.beforeEach((to, from, next) => {
  // hide any open bootstrap modals/backdrops to avoid DOM reparenting issues
  // (prevents runtime "parentNode of null" when Vue patches components during navigation)
  hideAllBootstrapModals();

  window.scrollTo({ top: 0, behavior: "smooth" });
  if (typeof document !== "undefined") {
    document.body.classList.remove("expand-menu");
    window.dispatchEvent(new CustomEvent("collapse-side-menus"));
  }

  const expired = isTokenExpired();
  const publicPaths = ["/", "/signup"];
  const user = expired ? null : getCurrentUser();
  const role = user?.role;
  const devDefaultPath = "/support/pending-societes";
  const defaultAuthenticatedPath = role === "Dev" ? devDefaultPath : "/dashboard";

  if (expired && !publicPaths.includes(to.path)) {
    return next("/");
  }

  if (!expired && publicPaths.includes(to.path)) {
    return next(defaultAuthenticatedPath);
  }

  if (role === "Dev") {
    const devAllowedPaths = [devDefaultPath, "/profile"];
    if (devAllowedPaths.includes(to.path)) {
      return next();
    }
    if (!to.path.startsWith("/support")) {
      return next(devDefaultPath);
    }
  } else if (to.path.startsWith("/support")) {
    return next("/dashboard");
  }

  next();
});
